<template>
  <div>
    <Navbar style="z-index: 999;"/>
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <section class="qi-content">
        <header>
          <h1>Nova Atividade - Jovem Aprendiz</h1>
          <vs-divider />
          <p v-if="studentName" style="font-size: 0.95em; color: gray;">
            Aluno selecionado: <strong style="color: black;">{{ studentName }} (RA: {{ studentRa }})</strong><br/>
            Filial: <strong style="color: black;">{{ filial }}</strong> | 
            Curso: <strong style="color: black;">{{ curso }}</strong>
          </p>
        </header>

        <vs-row>
          <vs-col vs-w="12">
            <vs-card>
              <div slot="header">
                <h3>Preencha os dados da Atividade</h3>
              </div>
              
              <vs-row>
                <vs-col vs-w="6" vs-sm="12" style="padding: 10px;">
                  <vs-input
                    type="date"
                    label="Data Inicial: *"
                    v-model="form.dataInicio"
                    style="width: 100%"
                  />
                </vs-col>
                <vs-col vs-w="6" vs-sm="12" style="padding: 10px;">
                  <vs-input
                    type="date"
                    label="Data Final: *"
                    v-model="form.dataFim"
                    style="width: 100%"
                  />
                </vs-col>
              </vs-row>

              <vs-row>
                <vs-col vs-w="6" vs-sm="12" style="padding: 10px;">
                  <vs-input
                    type="number"
                    label="Carga Horária (em horas): *"
                    v-model="form.cargaHoraria"
                    style="width: 100%"
                  />
                </vs-col>
                <vs-col vs-w="6" vs-sm="12" style="padding: 10px;">
                  <vs-input
                    type="text"
                    label="Local de Realização: *"
                    v-model="form.local"
                    style="width: 100%"
                  />
                </vs-col>
              </vs-row>

              <vs-row style="margin-top: 20px;">
                <vs-col vs-w="12" style="padding: 10px; display: flex; justify-content: flex-end;">
                  <vs-button 
                    color="danger" 
                    type="border" 
                    icon="cancel" 
                    style="margin-right: 10px;"
                    @click="$router.push('/apprentice')"
                  >
                    Cancelar
                  </vs-button>

                  <vs-button 
                    color="success" 
                    type="filled" 
                    icon="save" 
                    :disabled="!isFormValid"
                    @click="saveActivity"
                  >
                    Salvar Atividade
                  </vs-button>
                </vs-col>
              </vs-row>
            </vs-card>
          </vs-col>
        </vs-row>

      </section>
    </div>
  </div>
</template>

<script>
import Mailing from "../services/mailing";

export default {
  name: "YoungApprentice",
  data: () => ({
    studentRa: null,
    studentName: null,
    idHabilitacaoFilial: null,
    idPerLet: null,
    codColigada: '1',
    curso: null, 
    filial: null,
    form: {
      dataInicio: null,
      dataFim: null,
      cargaHoraria: null,
      local: null,
    }
  }),
  computed: {
    isFormValid() {
      return this.form.dataInicio && this.form.dataFim && this.form.cargaHoraria && this.form.local;
    }
  },
  created() {
    this.studentRa = this.$route.query.ra;
    this.studentName = this.$route.query.name;
    this.idHabilitacaoFilial = this.$route.query.idHabilitacao;
    this.idPerLet = this.$route.query.idPerLet;
    this.codColigada = this.$route.query.codColigada || '1';
    this.curso = this.$route.query.curso; 
    this.filial = this.$route.query.filial; 
  },
  methods: {
    saveActivity() {
      this.$vs.loading();

      const payload = {
        CODCOLIGADA: this.codColigada,
        IDHABILITACAOFILIAL: this.idHabilitacaoFilial,
        RA: this.studentRa,
        IDPERLET: this.idPerLet,
        CARGAHORARIA: this.form.cargaHoraria,
        DATAINICIO: this.form.dataInicio,
        DATAFIM: this.form.dataFim,
        LOCAL: this.form.local
      };

      new Mailing()
        .createApprenticeActivity(payload)
        .then(() => {
          this.$vs.notify({
            title: "Sucesso",
            text: "Atividade de Jovem Aprendiz salva com sucesso!",
            color: "success",
            position: "top-center",
          });
          this.$router.push('/apprentice');
        })
        .catch((error) => {
          this.$vs.notify({
            title: "Erro ao salvar",
            text: error.response?.data?.error || "Ocorreu um erro inesperado.",
            color: "danger",
            position: "top-center",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    }
  }
};
</script>